import { useRef, useEffect } from 'react';
import { promiseListener } from 'redux/store';

const usePromiseSubmit = ({ start, resolve, reject, onSuccess, onFailure, onSubmit, beforeSubmit }) => {

  const unsubscribeFn = useRef();

  // NB: When unmounting the component, the promise is cancelled and onSucces, onFailure might not run!
  useEffect(() => {
    return () => unsubscribeFn.current ? unsubscribeFn.current() : ({});
  }, []);

  if (!start || !resolve || !reject) {
    // Simple submit
    return (data, form) => {
      const payload = beforeSubmit ? beforeSubmit(data, form) : data;
      const submitResult = onSubmit(payload, form);

      if (submitResult instanceof Promise && onSuccess) {
        submitResult.then(() => onSuccess(payload, form));
      } else if (onSuccess) {
        onSuccess(payload, form); // Not actually checking if successful...
      }

      // TODO?
      // if (submitResult instanceof Promise && onFailure) {
      //   submitResult.catch(() => onFailure(payload, form));
      // }

      return submitResult;
    };
  }

  // Promise submit
  return (data, form) => {

    const { asyncFunction, unsubscribe } = promiseListener.createAsyncFunction({ start, resolve, reject });

    unsubscribeFn.current = unsubscribe;

    const payload = beforeSubmit ? beforeSubmit(data, form) : data;

    const promise = payload instanceof Promise
      ? payload.then(resolvedPayload => asyncFunction(resolvedPayload))
      : asyncFunction(payload);

    return promise.then(
      response => {
        if (onSuccess) { onSuccess(response, form); }
      },
      err => {
        if (onFailure) { onFailure(err, form); }
        return err;
      },
    );
  };
};

export default usePromiseSubmit;
